import { Expose, Type } from 'class-transformer';

// Enum

export enum ApprovalRefundEnum {
  Information = 'information',
  Customer = 'customer',
  Agent = 'agent',
}

export enum ApprovalableTypeEnum {
  Sale = 'Sale',
  Purchase = 'Purchase',
  Refund = 'Refund',
  ReleaseSale = 'ReleaseSale',
  ReleasePurchase = 'ReleasePurchase',
  AccountReceivable = 'AccountReceivable',
  AccountPayable = 'AccountPayable',
  Receipt = 'Receipt',
  Transfer = 'Transfer',
  BalanceAdjustment = 'BalanceAdjustment',
  BankTransaction = 'BankTransaction',
  CashTransaction = 'CashTransaction',
  IncomeAndCost = 'IncomeAndCost',
  Project = 'Project',
  Tour = 'Tour',
  TourFlight = 'TourFlight',
  TourHotel = 'TourHotel',
  OtherExpenses = 'OtherExpense',
  OtherIncome = 'OtherIncome',
  SaleProject = 'SaleProject',
  OrderAdjustment = 'OrderAdjustment',
}

export enum ApprovaleableWorkflowEnum {
  Sale = 'sale',
  SaleProject = 'sale_project',
}

// Model

export class getEnumsInput {
  class: string;
}

export class EnumResult {
  label: string;
  value: string;
}

export enum ColumnEnum {
  string = 'string',
  number = 'number',
  integer = 'integer',
  date = 'date',
  nested = 'nested',
}

export class ColumnReport {
  name: string;
  label: string;
  type: ColumnEnum;
  columns?: ColumnReport[];
}

export type FileInputType = {
  id?: string;
  file: string;
  url?: string | null;
};

export enum PivotAggregateFormatEnum {
  money = 'money',
  numeric = 'numeric',
  percentage = 'percentage',
}

export class PivotAggregateRowModel {
  name: string;
  label: string;
  link?: string | null;
  format: PivotAggregateFormatEnum;
}

export class PivotRowModel {
  name: string;
  label: string;
  link?: string | null;

  @Expose({ name: 'show_pivot' })
  @Type(() => Boolean)
  showPivot: boolean;

  @Expose({ name: 'show_total' })
  @Type(() => Boolean)
  showTotal: boolean;

  @Expose({ name: 'display_show_total' })
  @Type(() => Boolean)
  displayShowTotal: boolean;
}

export class PivotItemModel {
  @Type(() => PivotAggregateRowModel)
  aggregates: PivotAggregateRowModel[];
  @Type(() => PivotRowModel)
  rows: PivotRowModel[];
}

export class PivotModel {
  @Type(() => PivotItemModel)
  default: PivotItemModel;
  @Type(() => PivotItemModel)
  value: PivotItemModel;

  @Expose({ name: 'is_editable' })
  @Type(() => Boolean)
  isEditable: boolean;
}

// Input

export type CommonParamsType = {
  page?: number;
  limit?: number;
  filter?: string;
  sort?: string;
};
